export function isMobile(): boolean {
  return !(document.body.offsetWidth < 1024);
}
